export enum AppConfigArea {
  Platform = 'platform',
  Appearance = 'appearance',
  PayinP2PProvider = 'payin_p2p_provider',
  PayoutP2PProvider = 'payout_p2p_provider',
  PayoutRequisitesAutomation = 'payout_requisites_automation',
  PayinRequisites = 'payin_requisites',
  PayinOrderAutomation = 'payin_order_automation',
  Tron = 'tron',
  P2PProvidersCommon = 'p2p_providers_common',
  ShopsCommon = 'shops_common',
  PayinOrders = 'payin_orders',
  PayoutOrders = 'payout_orders',
}
